import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, X } from "lucide-react";

const HotlineBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const phoneNumber = "+91 7030808257";

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        className="fixed top-0 left-0 right-0 z-[55] bg-primary text-black py-2 px-4"
        data-testid="hotline-banner"
      >
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 relative">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 animate-pulse">
              <Phone className="w-4 h-4" />
              <span className="font-bold text-sm">24/7 Hotline:</span>
            </div>
            <a
              href={`tel:${phoneNumber.replace(/\s/g, "")}`}
              className="font-heading text-lg hover:underline"
              data-testid="hotline-number"
            >
              {phoneNumber}
            </a>
            <span className="hidden sm:inline text-sm opacity-80">
              | Free consultation for franchise partners
            </span>
          </div>
          
          <button
            onClick={() => setIsVisible(false)}
            className="absolute right-0 p-1 hover:bg-black/10 rounded transition-colors"
            aria-label="Close banner"
            data-testid="close-hotline-banner"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default HotlineBanner;
